import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    fontFamily: 'Inter, sans-serif',
                }}>
                    <h2 style={{ marginBottom: '16px' }}>Something went wrong</h2>
                    <p style={{ color: '#666', marginBottom: '24px' }}>
                        An unexpected error occurred. Please try again.
                    </p>
                    <button
                        onClick={this.handleReset}
                        style={{
                            padding: '8px 24px',
                            cursor: 'pointer',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            background: '#f5f5f5',
                        }}
                    >
                        Try Again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export { ErrorBoundary };
